import { useEffect, useState } from 'react';

export default function useMediaQuery(query) {
  const getMatch = () => (typeof window !== 'undefined') && window.matchMedia(query).matches;

  const [matches, setMatches] = useState(getMatch);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const mql = window.matchMedia(query);
    const handler = e => setMatches(e.matches);
    mql.addEventListener?.('change', handler);
    // Safari/old
    mql.addListener?.(handler);
    setMatches(mql.matches);
    return () => {
      mql.removeEventListener?.('change', handler);
      mql.removeListener?.(handler);
    };
  }, [query]);

  return matches;
}
